<template>
  <van-popup
    v-model="showPopup"
    position="bottom"
    class="popup-style"
    get-container="#app"
    @close="onCancel"
    @closed="onCancel"
  >
    <div class="container-box">
      <div class="popup-header">
        <span class="cancel" @click="onCancel">取消</span>
        <span class="title">{{ fieldModel.customName }}</span>
        <span class="submit" @click="onSubmit">确认</span>
      </div>
      <div class="popup-container">
        <van-checkbox-group v-model="fieldModel.customValue">
          <van-cell-group inset>
            <van-cell
              v-for="(item, index) in enumList"
              :key="item"
              clickable
              @click="toggle(index)"
            >
              <template #title>
                <div class="flex">
                  <van-checkbox ref="checkboxes" :name="item" />
                  <span class="radio-title">{{ item }}</span>
                </div>
              </template>
            </van-cell>
          </van-cell-group>
        </van-checkbox-group>
      </div>
    </div>
  </van-popup>
</template>

<script>
import fieldMixin from '../mixins'
import { getUserCustomField } from '@/api/modules/custom'
export default {
  mixins: [fieldMixin],

  data() {
    return {
      enumList: []
    }
  },

  created() {
    this.fieldModel.customValue = this.fieldModel.customValue
      ? this.fieldModel.customValue.split(',')
      : []
    this.fetchEnum()
  },

  methods: {
    toggle(index) {
      this.$refs.checkboxes[index].toggle()
    },
    async fetchEnum() {
      const res = await getUserCustomField({
        customName: this.fieldModel.customName,
        tenantId: global.APP_CONFIG.tenantId
      })
      if (res.code === 0 && Array.isArray(res.data) && res.data.length > 0) {
        this.enumList = res.data[0].customValue.split(',')
        if (this.fieldModel.customValue && this.fieldModel.customValue.length) {
          this.fieldModel.customValue = this.fieldModel.customValue.filter((f) => {
            return this.enumList.includes(f)
          })
        }
      }
    },

    onSubmit() {
      if (
        this.fieldModel.isRequired === 1 &&
        this.fieldModel.customValue.length === 0
      ) {
        return this.$toast(`${this.fieldModel.customName}必须选择`)
      }
      this.onUpdate()
    }
  }
}
</script>

<style lang="less" scoped>
.popup-style {
  .flex {
    display: flex;
    max-height: 440px;
    .radio-title {
      margin-left: 16px;
    }
  }
  .container-box {
    position: relative;
    width: 100%;
    height: 100%;
    .popup-header {
      line-height: 50px;
      width: 100%;
      background-color: #fff;
      display: flex;
      justify-content: space-between;
      box-sizing: border-box;
      padding: 0 14px;
      font-size: 14px;
      position: absolute;
      top: 0;
      z-index: 3;
      .cancel {
        color: #5f667a;
      }
      .title {
        color: #262c37;
        font-weight: bold;
      }
      .submit {
        color: #3173cd;
      }
    }
    .popup-container {
      padding: 50px 16px 20px 16px;
      max-height: 390px;
      overflow-y: auto;
    }
  }
}
</style>
